import { createFileRoute } from '@tanstack/react-router'
import { BookingsPage } from '~/features/operations/BookingsPage'
import { weekBounds } from '~/features/operations/search'
import { bookingsQuery } from '~/features/operations/queries'
import { Gate, RouteError } from '~/features/operations/shared'
import { mayRead } from '~/features/org/guard'
import { sessionQuery } from '~/lib/session'

type Search = { week?: string; facility?: string }

export const Route = createFileRoute('/_app/verein/betrieb/belegung')({
  validateSearch: (s: Record<string, unknown>): Search => ({
    ...(typeof s.week === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(s.week) ? { week: s.week } : {}),
    ...(typeof s.facility === 'string' ? { facility: s.facility } : {}),
  }),
  loaderDeps: ({ search }) => ({ week: search.week }),
  loader: async ({ context, deps }) => {
    if (!(await mayRead(context.queryClient, 'ops.read'))) return
    const session = await context.queryClient.ensureQueryData(sessionQuery)
    const { from, to } = weekBounds(deps.week, session.active?.organization.timezone ?? 'Europe/Berlin')
    await context.queryClient.ensureQueryData(bookingsQuery(from, to))
  },
  component: () => (
    <Gate permission="ops.read">
      <BookingsPage />
    </Gate>
  ),
  errorComponent: RouteError,
})
